module.exports = __webpack_public_path__ + "static/img/3.34e9e81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/sp/3.png
// module id = J4BM
// module chunks = 0